import React, { useState } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

interface AdminAuthModalProps {
  onAuthenticated: () => void;
  onExit: () => void;
}

const AUTHORIZED_ADMIN_ID = import.meta.env.VITE_REACT_APP_ADMIN_UID;

export const AdminAuthModal = ({
  onAuthenticated,
  onExit,
}: AdminAuthModalProps) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!email || !password) return;
    setLoading(true);
    setError("");

    try {
      const auth = getAuth();
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password,
      );
      const user = userCredential.user;

      if (user.uid === AUTHORIZED_ADMIN_ID) {
        onAuthenticated();
      } else {
        await auth.signOut();
        setError("Access Denied: You do not have admin privileges.");
      }
    } catch (err: any) {
      setError("Invalid admin credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="admin-modal">
        <h2 className="admin-modal-header">Augio Admin Portal</h2>
        <div className="admin-input-group">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Admin Email"
            className="admin-input"
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="admin-input"
            onKeyDown={(e) => e.key === "Enter" && handleLogin()}
          />
          {error && (
            <p
              className="error-text"
              style={{ color: "red", fontSize: "0.8rem" }}
            >
              {error}
            </p>
          )}
        </div>
        <div className="admin-modal-actions">
          <button className="btn-secondary" onClick={onExit}>
            Exit
          </button>
          <button
            className="btn-primary"
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? <div className="spinner-btn"></div> : "Login"}
          </button>
        </div>
      </div>
    </div>
  );
};
